import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Modal } from "@/components/pcp";
import { toast } from "sonner";

// Vincula uma OS antiga (criada sem contrato) a um contrato, casando itens da OS com itens da planilha.
export function VincularContratoModal({ open, onClose, os, itens, onDone }) {
  const [contratos, setContratos] = useState([]);
  const [cid, setCid] = useState(os?.contrato_id || "");
  const [map, setMap] = useState({});

  useEffect(() => {
    if (!open) return;
    api.get("/contratos").then((r) => setContratos(r.data.filter((c) => (c.status || "Contrato") !== "Orçamento")));
    setCid(os?.contrato_id || "");
    setMap(Object.fromEntries((itens || []).map((i) => [i.id, i.contrato_item_id || ""])));
  }, [open, os, itens]);
  if (!open) return null;

  const contrato = contratos.find((c) => c.id === cid);
  const sugerir = () => {
    if (!contrato) return;
    const m = {};
    const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/m2/g, "m²").replace(/[^a-z0-9²]+/g, " ").trim();
    const normUn = (u) => ({ ml: "m", metro: "m", unid: "un", und: "un", unidade: "un" }[norm(u)] || norm(u));
    const parecido = (a, b) => { const A = new Set(a.split(" ")), B = new Set(b.split(" ")); const inter = [...A].filter((x) => B.has(x)).length; return inter / Math.max(A.size, B.size); };
    (itens || []).forEach((i) => {
      const cis = contrato.itens || [];
      const hit = (i.composicao_id && cis.find((ci) => ci.composicao_id === i.composicao_id || (ci.composicoes_ids || []).includes(i.composicao_id)))
        || (i.codigo && cis.find((ci) => norm(ci.codigo) === norm(i.codigo)))
        || cis.find((ci) => norm(ci.descricao) === norm(i.descricao) && normUn(ci.unidade) === normUn(i.unidade))
        || cis.filter((ci) => normUn(ci.unidade) === normUn(i.unidade)).map((ci) => [ci, parecido(norm(ci.descricao), norm(i.descricao))]).filter(([, r]) => r >= 0.8).sort((a, b) => b[1] - a[1])[0]?.[0]
        || cis.find((ci) => ci.categoria === i.categoria && normUn(ci.unidade) === normUn(i.unidade));
      m[i.id] = hit ? hit.id : "";
    });
    setMap(m);
  };
  const salvar = async () => {
    if (!cid) { toast.error("Escolha o contrato"); return; }
    try {
      await api.put(`/ordens/${os.id}/vincular-contrato`, { contrato_id: cid, mapeamento: map });
      toast.success("OS vinculada ao contrato"); onDone?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao vincular"); }
  };
  const vinculados = Object.values(map).filter(Boolean).length;

  return (
    <Modal open onClose={onClose} title={`Vincular OS ${os.numero} a um contrato`} size="lg">
      <div className="label">Contrato</div>
      <select className="select" value={cid} onChange={(e) => { setCid(e.target.value); setMap({}); }} data-testid="vc-contrato">
        <option value="">— selecione —</option>
        {contratos.map((c) => <option key={c.id} value={c.id}>{c.numero} · {c.contratante}</option>)}
      </select>
      {contrato && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 14 }}>
            <div className="label" style={{ margin: 0 }}>Casar itens da OS com a planilha ({vinculados}/{(itens || []).length})</div>
            <button className="btn btn-outline btn-sm" onClick={sugerir} data-testid="vc-sugerir">Sugerir automaticamente</button>
          </div>
          <table className="pcp-table" style={{ marginTop: 8 }}>
            <thead><tr><th>Item da OS</th><th>Un</th><th>Item do contrato</th></tr></thead>
            <tbody>
              {(itens || []).map((i) => (
                <tr key={i.id}>
                  <td>{i.descricao} <span className="chip" style={{ marginLeft: 6 }}>{i.categoria}</span></td>
                  <td>{i.unidade}</td>
                  <td>
                    <select className="select" style={{ padding: 6 }} value={map[i.id] || ""} onChange={(e) => setMap({ ...map, [i.id]: e.target.value })} data-testid={`vc-map-${i.id}`}>
                      <option value="">— não medir —</option>
                      {(contrato.itens || []).map((ci) => <option key={ci.id} value={ci.id}>{ci.codigo ? ci.codigo + " · " : ""}{ci.descricao} ({ci.unidade})</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 18 }}>
        <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
        <button className="btn btn-primary" onClick={salvar} data-testid="vc-salvar">Vincular</button>
      </div>
    </Modal>
  );
}
